import { render, staticRenderFns } from "./LoaderPickup.vue?vue&type=template&id=096c7a61&scoped=true&"
import script from "./LoaderPickup.vue?vue&type=script&lang=ts&"
export * from "./LoaderPickup.vue?vue&type=script&lang=ts&"
import style0 from "./LoaderPickup.vue?vue&type=style&index=0&id=096c7a61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096c7a61",
  null
  
)

export default component.exports